import React, { useMemo } from 'react';
import S from 'StyledEventListTreeLayout.js';
import {formatDateCustom} from 'datesHelper.js';
import { translation } from 'helpers/utilsHelper.js';
import { getThemeCookie } from 'helpers/cookiesHelper.js';
import CloseBtnDarkIcon from 'close-modal-btn-dark.svg';
import CloseBtnLightIcon from 'close-modal-btn-light.svg';
import BackBtnDarkIcon from 'back-modal-btn-dark.svg';
import BackBtnLightIcon from 'back-modal-btn-light.svg';
import SportCountArrowDarkIcon from 'count-arrow-right-dark.svg';
import SportCountArrowLightIcon from 'count-arrow-right-light.svg';
import CategoryCountArrowDownDarkIcon from 'category-arrow-down-dark.svg';
import CategoryCountArrowDownLightIcon from 'category-arrow-down-light.svg';


export const CategoryTreeHeaderTab = ({setCategoryLevel, categoryLevel, sportName, sportId, closeModalAcion, categoryLevelForBackBtn, parentCategoryName, parentCategoryId, categoryName, isPrematch}) => {

    const closeIcon = useMemo(() => {

        let cookie = getThemeCookie() ;
        return (cookie == 'theme-dark' ? CloseBtnDarkIcon : CloseBtnLightIcon);

    }, []);

    const backIcon = useMemo(() => {

        let cookie = getThemeCookie();
        return (cookie == 'theme-dark' ? BackBtnDarkIcon : BackBtnLightIcon);

    }, []);

    const headerClassName =  `${(categoryLevel == 1 ? 'categoryLevel1':'categoryLevel0')}${(isPrematch == true ? 'isPrematch':'')}`;

    return (
        <S.Header className={ headerClassName }>

            { categoryLevel == 3 && 
                <>
                    <S.BackModalButton onClick={() => setCategoryLevel(categoryLevelForBackBtn) } className={`back-btn`} dangerouslySetInnerHTML={{__html: backIcon}}></S.BackModalButton> 
                    <S.SportNameHeader className={ isPrematch ? 'center':'' }>{categoryName}</S.SportNameHeader>
                </>  
            }

            { categoryLevel == 2 &&
                <>
                    <S.BackModalButton onClick={() => setCategoryLevel(categoryLevelForBackBtn) } className={`back-btn`} dangerouslySetInnerHTML={{__html: backIcon}}></S.BackModalButton> 
                    <S.SportIconHeader src={app.config.getStaticImageForCategories(parentCategoryId)} onError={(e) => app.config.handleIncorrectImages(e)}></S.SportIconHeader>
                    <S.SportNameHeader>{parentCategoryName}</S.SportNameHeader>
                </>
            }

            { categoryLevel == 1 && 
                <>
                    <S.BackModalButton onClick={() => setCategoryLevel(categoryLevelForBackBtn) } className={`back-btn`} dangerouslySetInnerHTML={{__html: backIcon}}></S.BackModalButton> 
                    <S.SportIconHeader src={app.config.getStaticImageForCategories(sportId)} onError={(e) => app.config.handleIncorrectImages(e)}></S.SportIconHeader>
                    <S.SportNameHeader>{sportName}</S.SportNameHeader>
                </>  
            }

            { categoryLevel == 0 &&
                 <S.AllSportHeader> {translation(`eventListTree_allSports`)} </S.AllSportHeader> 
            }
            
            <S.CloseModalButton onClick={() => closeModalAcion() } className={`close-btn`} 
                dangerouslySetInnerHTML={{__html: closeIcon}}></S.CloseModalButton>

        </S.Header>
    )
};


export const CategoryTreeSportTab = ({categoryId, categoryName, categoryCount, selectSport, showIcon}) => {

    const sportCountArrowIcon = useMemo(() => {

        let cookie = getThemeCookie();
        return (cookie == 'theme-dark' ? SportCountArrowDarkIcon : SportCountArrowLightIcon);

    }, []);

    return (
        <S.RowTab onClick={() => selectSport(categoryId, categoryName)}>
            {showIcon && <S.SportIcon src={app.config.getStaticImageForCategories(categoryId)} onError={(e) => app.config.handleIncorrectImages(e)}>
            </S.SportIcon> }
            <S.RowTabText className={ !showIcon ? 'iconHidden':'' }>
                { categoryName }
            </S.RowTabText>
            <S.RowTabCountText>
                { categoryCount }
            </S.RowTabCountText>
            <S.RowTabCountArrowContainer>
                <S.SportCountArrow className={`sport-count-arrow`} dangerouslySetInnerHTML={{__html: sportCountArrowIcon}}>
                </S.SportCountArrow>
            </S.RowTabCountArrowContainer>
        </S.RowTab>
    )

};

export const CategoryTreeLiveEventTab = ( { event, openLiveEventId } ) => {
    const { eventName, participants, eventId, infos, time, sportId } = event;
    

    const getParticipantEventNames = (eventName) => {
        if (!eventName){
            return ['',''];
        }
        return eventName.replace(' (live)', '').split(' - ');
    };

    const getScores = (event) => {
        const sportId = event.sportId;
        let scoreTab = [];
    
        switch (sportId) {
          // Soccer 1, Basketball 2, Ice Hockey 4, Handball 6, Rugby 12, American Football 16, Futsal 29, Baseball 3, Snooker 19 - display only main score
          case 1:
          case 2:
          case 3:
          case 4:
          case 6:
          case 12:
          case 16:
          case 19:
          case 29: {
            const gameScore = event.result === "?-?" ? "?:?" : event.result;
            scoreTab.push(gameScore);
            break;
          }
          // Tennis 5 - display set score, current set game score, current game point score
          case 5: {
            const setScore = event.result === "?-?" ? "?:?" : event.result;
            const currentSetGameScore = event.partialScores?.split(' - ').pop() || "?:?";
            const currentGamePointScore = event.score;
            scoreTab.push(currentGamePointScore, currentSetGameScore, setScore );
            break;
          }
          // Badminton 31, Beach Volleyball 34, Volleyball 10, Table Tennis 20 - display set score and current set game score
          case 10:
          case 20:
          case 31:
          case 34: {
            const setScore = event.result === "?-?" ? "?:?" : event.result;
            const currentSetGameScore = event.partialScores?.split(' - ').pop() || "?:?";
            scoreTab.push(setScore, currentSetGameScore);
            break;
          }
        }
    
        return scoreTab;
    };

    const parseLiveTime = (time) => {
        let output = '';
    
        if (time !== 0) {
          output += Math.floor(time / 60) + '\'';
        }
        return output;
    };

    const getParticipantScore = (scores, participantIndex, sportId) => {
        let tab = [];
        for (let [index, scoreObj] of scores.entries()){
            let score = scoreObj.split(':')[participantIndex];
            tab.push(
                <S.ParticipantScore key={`${participantIndex}-${index}`}
                    className={`${((sportId == 5 && index==scores.length-1) || (sportId != 5 && index==0)) ? 'set-result': ''}`}>
                    { score }
                </S.ParticipantScore>
            );
        }
        return tab;
    };

    const liveInfo = `${(time ? parseLiveTime(time) : '')}  ${(infos && infos[0] ? infos[0].info : '')}`;
    const scores = getScores(event);
    const participantNames = getParticipantEventNames(eventName);

    let team1ParticipantRemoteId = 0;
    let team2ParticipantRemoteId = 0;
    if(participants && Array.isArray(participants) && participants.length) {
        team1ParticipantRemoteId = _.find(participants, {number: 1}).remoteParticipantId;
        team2ParticipantRemoteId = _.find(participants, {number: 2}).remoteParticipantId;
    }

    return (
        <>
            <S.EventRowTab onClick={() =>  app.router.redirect('live/event/:eventId', { eventId: eventId })}>
                { openLiveEventId == eventId && <S.MarkEventActive></S.MarkEventActive> }
                <S.EventParticipantsColumn>
                    <S.EventParticipantNameContainer className="participant1">
                        <S.ParticipantIconWrapper className="participant1">
                            <S.ParticipantIcon src={app.config.getStaticImageForParticipant(team1ParticipantRemoteId)} onError={(e) => app.config.handleIncorrectImages(e)}></S.ParticipantIcon>
                        </S.ParticipantIconWrapper>
                        <S.EventParticipantName className="participant1"> { participantNames[0] } </S.EventParticipantName>
                    </S.EventParticipantNameContainer>
                    <S.EventParticipantNameContainer className="participant2">
                        <S.ParticipantIconWrapper className="participant2">
                            <S.ParticipantIcon src={app.config.getStaticImageForParticipant(team2ParticipantRemoteId)} onError={(e) => app.config.handleIncorrectImages(e)}></S.ParticipantIcon>
                        </S.ParticipantIconWrapper>
                        <S.EventParticipantName className="participant2"> { participantNames[1] } </S.EventParticipantName>
                    </S.EventParticipantNameContainer>
                </S.EventParticipantsColumn>
                <S.EventInfoColumn> { liveInfo } </S.EventInfoColumn>
                <S.EventMatchResultColumn>
                    <S.EventMatchResultParticipant1>
                        <S.ParticipantScoresContainer className="p1"> { getParticipantScore(scores, 0, sportId) } </S.ParticipantScoresContainer>
                    </S.EventMatchResultParticipant1>
                    <S.EventMatchResultParticipant2>
                        <S.ParticipantScoresContainer className="p2"> { getParticipantScore(scores, 1, sportId) } </S.ParticipantScoresContainer>
                    </S.EventMatchResultParticipant2>
                </S.EventMatchResultColumn>
            </S.EventRowTab>
            <S.EventRowTabBottomBorder></S.EventRowTabBottomBorder>
        </>
    );
};


export const CategoryTreeCategoryTab = ({categoryId, parentId, categoryName, categoryCount, openCategoryIdTabs, toggleCategoryTab, getEventsList, events}) => {

    const categoryCountArrowIcon = useMemo(() => {

        let cookie = getThemeCookie();
        return (cookie == 'theme-dark' ? CategoryCountArrowDownDarkIcon : CategoryCountArrowDownLightIcon);

    }, []);

    return (
        <>
            <S.CategoryRowTab onClick={() => toggleCategoryTab(categoryId)}>
                <S.SportIcon src={app.config.getStaticImageForCategories(parentId)} onError={(e) => app.config.handleIncorrectImages(e)}>
                </S.SportIcon>
                <S.RowTabText>
                    { categoryName }
                </S.RowTabText>
                <S.RowTabCountText>
                    { categoryCount }
                </S.RowTabCountText>
                <S.RowTabCountArrowContainer>
                        <S.CategoryCountArrow className={openCategoryIdTabs.indexOf(categoryId)>-1 ? 'open':''} dangerouslySetInnerHTML={{__html: categoryCountArrowIcon}}>
                        </S.CategoryCountArrow> 
                </S.RowTabCountArrowContainer>
            </S.CategoryRowTab>
            <S.EventsContainer className={openCategoryIdTabs.indexOf(categoryId)>-1 ? 'open':''}>
                { getEventsList(events) }
            </S.EventsContainer>
        </>
    )
};

export const CategoryTreePrematchEventTab = ( { event } ) => {

    const { eventName, eventStart, eventId, participants } = event;

    const getParticipantEventNames = (eventName) => {
        if (!eventName){
            return ['',''];
        }
        return eventName.split(' - ');
    };

    const getEventStart = (eventStart) => {
        return formatDateCustom(new Date(eventStart), 'dd sm HH:mm'); 
    };

    const participantNames = getParticipantEventNames(eventName);

    let team1ParticipantRemoteId = 0;
    let team2ParticipantRemoteId = 0;
    if(participants && Array.isArray(participants) && participants.length) {
        team1ParticipantRemoteId = _.find(participants, {number: 1})?.remoteId
        team2ParticipantRemoteId = _.find(participants, {number: 2})?.remoteId
    }

    return (
        <>
            <S.EventPrematchRowTab onClick={() =>  app.router.redirect('sports/event/:eventId', { eventId: eventId })}>
                <S.EventPrematchStartDateRow> { getEventStart(eventStart) } </S.EventPrematchStartDateRow>
                <S.EventPrematchNameRow>
                    <S.EventPrematchParticipantNameContainer className="participant1">
                        <S.EventPrematchParticipantName className="participant1"> { participantNames[0] } </S.EventPrematchParticipantName>
                        <S.ParticipantIconWrapper className="participant1">
                            <S.ParticipantIcon src={app.config.getStaticImageForParticipant(team1ParticipantRemoteId)} onError={(e) => app.config.handleIncorrectImages(e)}></S.ParticipantIcon>
                        </S.ParticipantIconWrapper>
                        
                    </S.EventPrematchParticipantNameContainer>
                    <S.EventPrematchParticipantNameContainer className="participant2">
                        <S.ParticipantIconWrapper className="participant2 prematch">
                            <S.ParticipantIcon src={app.config.getStaticImageForParticipant(team2ParticipantRemoteId)} onError={(e) => app.config.handleIncorrectImages(e)}></S.ParticipantIcon>
                        </S.ParticipantIconWrapper>
                        <S.EventPrematchParticipantName className="participant2"> { participantNames[1] } </S.EventPrematchParticipantName>
                    </S.EventPrematchParticipantNameContainer>
                </S.EventPrematchNameRow>
            </S.EventPrematchRowTab>
        </>
    );

};

